import {
  QuackchatSessionConfigurationResponse,
  UpdateQuackchatSessionConfigurationRequest,
} from "@/api/quackchat/configuration/useQuackchatSessionConfiguration";
import { OptionalFieldGroup } from "./FieldGroup";
import { Em, Flex, Text } from "@radix-ui/themes";
import Switch from "@/components/shared/inputs/switch";

interface AskEmailInFirstClientMessageProps {
  quackchatSessionConfiguration: QuackchatSessionConfigurationResponse | null;
  updateQuackchatSessionConfiguration: (
    request: UpdateQuackchatSessionConfigurationRequest
  ) => void;
}

export function AskEmailInFirstClientMessage({
  quackchatSessionConfiguration,
  updateQuackchatSessionConfiguration,
}: AskEmailInFirstClientMessageProps) {
  const askEmailAfterFirstMessage =
    quackchatSessionConfiguration?.askEmailAfterFirstMessage ?? false;
  const askEmailAfterFirstMessageOnlyIfMissing =
    quackchatSessionConfiguration?.askEmailAfterFirstMessageOnlyIfMissing ??
    false;

  return (
    <OptionalFieldGroup
      label="Ask Email In First Client Message"
      description="Configure email collection settings for the first client message"
      enabled={askEmailAfterFirstMessage}
      toggleEnabled={(nextValue) =>
        updateQuackchatSessionConfiguration({
          askEmailAfterFirstMessage: nextValue,
        })
      }
    >
      {askEmailAfterFirstMessage && (
        <Flex
          width={"100%"}
          justify={"between"}
          gap={"3"}
          className="bg-muted py-2 px-3 rounded-md"
        >
          <Text size={"2"} color={"gray"}>
            <Em>Only ask for email if the user didn't identify their email.</Em>
          </Text>

          <Flex flexShrink={"0"} pr={"1"}>
            <Switch
              value={askEmailAfterFirstMessageOnlyIfMissing}
              onChange={() =>
                updateQuackchatSessionConfiguration({
                  askEmailAfterFirstMessageOnlyIfMissing:
                    !askEmailAfterFirstMessageOnlyIfMissing,
                })
              }
            />
          </Flex>
        </Flex>
      )}
    </OptionalFieldGroup>
  );
}
